export const veiculosList = [
  {
    label: 'Automóvel',
  },
  {
    label: 'Ônibus',
  },
  {
    label: 'Bicicleta',
  },
  {
    label: 'Outros',
  },
  {
    label: 'Não informado',
  },
  {
    label: 'Caminhão',
  },
  {
    label: 'Motocicleta',
  },
];
export const locationTypeList = [
  {
    label: 'Geometric center para meio de quadra',
  },
  {
    label: 'Approximate',
  },
  {
    label: 'Não encontrado',
  },
];
export const statusSAMU = [{ label: 'Sim' }, { label: 'Não' }];
export const tipoEngenharia = [
  {
    label: 'Infraestrutura Cicloviária',
  },
  {
    label: 'Infraestrutura para Pedestres',
  },
  {
    label: 'Infraestrutura para Ônibus',
  },
  {
    label: 'Semáforo',
  },
  {
    label: 'Operação e Interdição de Pista',
  },
  { label: 'Moderação de Tráfego' },
  {
    label: 'Renovação/Implantação de Sinalização',
  },
  { label: 'Projeto Geométrico' },
  { label: 'Planejamento e Análise' },
  {
    label: 'Outros',
  },
];
export const tipoEspecEngenharia = [
  {
    label: 'Ciclovia',
  },
  {
    label: 'Ciclofaixa Unidirecional',
  },
  {
    label: 'Ciclofaixa Unidirecional com Segregador',
  },
  {
    label: 'Ciclofaixa Bidirecional ',
  },
  {
    label: 'Ciclofaixa Bidirecional com Segregador',
  },
  {
    label: 'Ciclorrota',
  },
  {
    label: 'Travessia Elevada',
  },
  {
    label: 'Faixa Diagonal',
  },
  {
    label: 'Ilha de Refúgio',
  },
  {
    label: 'Calçada Verde',
  },
  {
    label: 'Extensão do Meio-fio',
  },
  {
    label: 'Interseção Elevada',
  },
  {
    label: 'Faixa de Pedestre',
  },
  {
    label: 'Faixa Exclusiva de Ônibus',
  },
  {
    label: 'Sinalização de Parada de Ônibus',
  },
  {
    label: 'BRT',
  },
  {
    label: 'BRS',
  },
  {
    label: 'Convencional',
  },
  {
    label: 'Centralizado',
  },
  {
    label: 'Recape',
  },
  {
    label: 'Desvio e Obra',
  },
  {
    label: 'Tapa-Buraco',
  },
  {
    label: 'Lombada Física',
  },
  {
    label: 'Fiscalização Eletrônica',
  },
  {
    label: 'Chicanas',
  },
  {
    label: 'Área de Trânsito Calmo',
  },
  {
    label: 'Redutor de Velocidade',
  },
  {
    label: 'Readequação do Limite de Velocidade',
  },
  {
    label: 'Horizontal',
  },
  {
    label: 'Vertical',
  },
  {
    label: 'Horizontal e Vertical',
  },
  {
    label: 'Projeto Escola',
  },
  {
    label: 'Zona Azul',
  },
  {
    label: 'Esquina Segura Convencional',
  },
  {
    label: 'Esquina Segura 2.0',
  },
  {
    label: 'Videomonitoramento',
  },
  {
    label: 'Sinalização Turística',
  },
  {
    label: 'X de Garagem',
  },
  {
    label: 'Márcação de Área de Conflito',
  },
  {
    label: 'Ponto de Táxi/Mototáxi',
  },
  {
    label: 'Regulamentação de Estacionamento',
  },
  {
    label: 'Vaga Especial',
  },
  {
    label: 'Marcação de Carga/Descarga',
  },
  {
    label: 'Abertura/Fechamento Canteiro',
  },
  {
    label: 'Reconstrução de Passeio',
  },
  {
    label: 'Corredor',
  },
  {
    label: 'Projeto Especial',
  },
  {
    label: 'Polo Turístico',
  },
  {
    label: 'Rotatória',
  },
  {
    label: 'Mini-Rotatória',
  },
  {
    label: 'Circulação',
  },
  {
    label: 'RIST',
  },
  {
    label: 'Pesquisa',
  },
  {
    label: 'Recurso',
  },
  {
    label: 'Contagem de Tráfego ',
  },
  {
    label: 'Análise de Conflitos',
  },
  {
    label: 'Vistoria',
  },
  {
    label: 'Outros',
  },
];
export const statusEngenharia = [
  {
    label: 'Solicitado',
  },
  {
    label: 'Aguardando projeto',
  },
  {
    label: 'Em projeto',
  },
  {
    label: 'Projetado',
  },
  {
    label: 'Aguardando execução',
  },
  {
    label: 'Em execução',
  },
  {
    label: 'Concluído',
  },
  {
    label: 'Desativado',
  },
  {
    label: 'Indeferido',
  },
];

export const tipoFicalizacao = [
  {
    label: 'Comando',
  },
  {
    label: 'Rota de Fiscalização',
  },
  {
    label: 'Bloqueio',
  },
  {
    label: 'Apoio Semáforo',
  },
  {
    label: 'Fiscalização Itinerante',
  },
  {
    label: 'Reserva de Vaga',
  },
  {
    label: 'Volante',
  },
  {
    label: 'Outros',
  },
];
export const tipoFiscalizacaoEducacao = [
  {
    label: 'AMC itinerante',
  },
  {
    label: 'AMC nas escolas',
  },
  {
    label: 'AMC nos bares',
  },
  {
    label: 'Bike sem barreiras',
  },
  {
    label: 'Capacitação',
  },
  {
    label: 'Ciclofaixa de lazer',
  },
  {
    label: 'Ciclofaixa segura',
  },
  {
    label: 'Comando de saúde',
  },
  {
    label: 'Comando educativo',
  },
  {
    label: 'Curso de pilotagem segura para ciclista',
  },
  {
    label: 'Curso de pilotagem segura para motociclista',
  },
  {
    label: 'Palestra',
  },
  {
    label: 'Passeio ciclístico',
  },
  {
    label: 'Um dia de trânsito',
  },
];

export const focoFiscalizacao = [
  {
    label: 'Geral',
  },
  {
    label: 'Educativo',
  },
  {
    label: 'Lei Seca',
  },
  {
    label: 'Uso Correto do Cinto de Segurança',
  },
  {
    label: 'Estacionamento (Zona Azul)',
  },
  {
    label: 'Esquina Segura',
  },
  {
    label: 'Sucata (NVA)',
  },
  {
    label: 'Sem Veículo (SUV)',
  },
  {
    label: 'AET',
  },
  {
    label: 'Operacional',
  },
  {
    label: 'Outro',
  },
];

export const focoFiscalizacaoEducacao = [
  {
    label: 'Apoio a evento',
  },
  {
    label: 'Captação',
  },
  {
    label: 'Ciclistas',
  },
  {
    label: 'Crianças',
  },
  {
    label: 'Geral',
  },
  {
    label: 'Idosos/PcD',
  },
  {
    label: 'Lei Seca',
  },
  {
    label: 'Motociclistas',
  },
  {
    label: 'Ocupantes de automóveis',
  },
  {
    label: 'Outros',
  },
  {
    label: 'Pedestres',
  },
  {
    label: 'Ponto cego caminhão',
  },
  {
    label: 'Ponto cego onibus',
  },
  {
    label: 'Público interno',
  },
  {
    label: 'Transporte de pet',
  },
  {
    label: 'Volta às aulas',
  },
];

export const gravidadesList = [
  {
    label: 'Ileso',
  },
  {
    label: 'Ferido',
  },
  {
    label: 'Fatal',
  },
  {
    label: 'Não informado',
  },
];

export const locationList = [
  {
    label: 'Meio de Quadra',
  },
  {
    label: 'Cruzamento',
  },
];

export const tipoAcidentesList = [
  {
    label: 'Colisão',
  },
  {
    label: 'Choque c/ Obstáculo Fixo',
  },
  {
    label: 'Queda',
  },
  {
    label: 'Atropelamento',
  },
  {
    label: 'Outros',
  },
  {
    label: 'Capotamento',
  },
];

export const bairrosList = [
  {
    label: 'Centro',
  },
  {
    label: 'Pici',
  },
  {
    label: 'Siqueira',
  },
  {
    label: 'Aldeota',
  },
  {
    label: 'Papicu',
  },
  {
    label: 'Jangurussu',
  },
];

export const jurisdicaoList = [
  {
    label: 'Municipal',
  },
];

export const intersecaoList = [
  {
    label: 'Sim',
  },
];

export const severidade = [
  {
    label: 'Ileso',
  },
];

export const elementosAtingidosList = [
  {
    label: 'Nenhum',
  },
];

export const viaOuCruzamentoList = [
  {
    label: 'Municipal',
  },
];

export const responsaveisList = [
  {
    label: 'Responsável 1',
  },
  { label: 'Responsável ' },
];

export const projectRadio = [
  {
    label: 'Sim',
  },
  {
    label: 'Não',
  },
  {
    label: 'Sim, com alterações',
  },
];
